// extracted by mini-css-extract-plugin
module.exports = {"form":"AccessControlForm_form__2QCdE"};